import store from "@/core/store";
import toast from "@/core/utils/toast";

export default function mobile({next, router}) {
    if (!store.getters.mobileIsVerified) {
        toast.info('تلفن همراه خود را تایید کنید', {
            position: 'bottomCenter',
            transitionIn: 'fadeInUp',
            transitionOut: 'fadeOutDown'
        })
        return router.push({
            name: 'account.index'
        }).catch(() => {
        });

    }

    return next();
}